// Utility to truncate a string and add ellipsis if needed
export function truncateWithEllipsis(text: string, maxLength: number): string {
  if (!text) return '';
  let truncated = text.length > maxLength ? text.substring(0, maxLength) : text;
  // Remove trailing periods, '…', or '...'
  truncated = truncated.replace(/(\.{1,3}|…)+$/, '');
  return truncated + '…';
}
